import { axios } from '@/api/common'
import { queryOptions } from '@tanstack/react-query'
import { Inv2010GetResultModel, Inv2010GetResultSchema } from './get.schema'

export async function fetchInv2010(id: number): Promise<Inv2010GetResultModel> {
  const response = await axios.get<Inv2010GetResultModel>(
    `/api/warehouse/inv2010/${id}`
  )
  return Inv2010GetResultSchema.parse(response.data)
}

export const getInv2010ByIdOptions = (id: number) =>
  queryOptions({
    queryKey: ['inv2010', id],
    queryFn: () => fetchInv2010(id),
  })
